import React from 'react'

import "./published.css"
import gregWatkinson from "../../../assets/brand/gregwatkinson.jpg"
import { ReactGAImplementation } from 'react-ga4';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import {useEffect } from 'react'

function useTrackPageViews() {
  let location = useLocation();
  useEffect(() => {
  // Track page view with react-ga4
  ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
  }

export default function Published() {
  useTrackPageViews();  
  return (
    
    <div className='emas__published'>
        <div className='emas__published-content'>
            <div className='emas__published-content_top'>
                <p>Copyright © Electricity Market Advisory Services Pty Ltd 2026</p>
                <p>Electricity Market Advisory Services Pty Ltd (ACN 663 507 828) does not guarantee, and accepts no legal liability arising from or connected to, the accuracy, reliability, currency or completeness of any material contained on this website. Parties should seek appropriate independent professional advice prior to relying on or entering into any commitment based on material published here.</p>
            </div>
        </div>
    </div>
  )
}
